// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.future-config-bg-delete[data-v-13c305a2] {\n  background-color: #ffc7c7;\n}\n.future-config-bg-create[data-v-13c305a2] {\n  background-color: #d0efcf;\n}\n.future-config-bg-update[data-v-13c305a2] {\n  background-color: #fff2b6;\n}\n.allocation-config-tooltip[data-v-13c305a2] {\n  white-space:nowrap;\n  max-width:none;\n}\n", ""]);
// Exports
module.exports = exports;
